import { render, staticRenderFns } from "./SundryItemList.vue?vue&type=template&id=1b804a18&scoped=true&"
import script from "./SundryItemList.vue?vue&type=script&lang=js&"
export * from "./SundryItemList.vue?vue&type=script&lang=js&"
import style0 from "./SundryItemList.vue?vue&type=style&index=0&id=1b804a18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b804a18",
  null
  
)

export default component.exports